import { VisitNode } from './types'

type PreserveEmptyLinesPluginProps = {
    enabled: boolean
}

export const preserveEmptyLines = ({ enabled }: PreserveEmptyLinesPluginProps) => {
    function transformer(tree: VisitNode) {
        if (!enabled || !('children' in tree) || !Array.isArray(tree.children)) {
            return
        }

        const children = tree.children
        const newChildren: typeof children = []

        const insertEmptyParagraphs = (count: number) => {
            for (let i = 0; i < count; i += 1) {
                newChildren.push({
                    type: 'paragraph',
                    children: [
                        {
                            type: 'text',
                            value: '||empty_text||',
                        },
                    ],
                })
            }
        }

        const firstStartLine = children[0]?.position?.start?.line
        if (typeof firstStartLine === 'number' && firstStartLine > 1) {
            insertEmptyParagraphs(firstStartLine - 1)
        }

        for (let i = 0; i < children.length; i += 1) {
            const current = children[i]
            newChildren.push(current)

            const next = children[i + 1]
            const currentEndLine = current?.position?.end?.line
            const nextStartLine = next?.position?.start?.line

            if (typeof currentEndLine === 'number' && typeof nextStartLine === 'number') {
                const blankLines = nextStartLine - currentEndLine - 1
                if (blankLines > 0) {
                    insertEmptyParagraphs(blankLines)
                }
            }
        }

        tree.children = newChildren
    }

    return transformer
}
